export function getMachineStatus(machine) {
  if (!machine.Last_signal) {
    return 'UNKNOWN';
  }

  const now = Date.now();
  const lastSignalTime = Date.parse(machine.Last_signal);
  const diffInSeconds = (now - lastSignalTime) / 1000;

  if (diffInSeconds >= 60 * 5) {
    return 'OFFLINE';
  }

  if (
    machine.QRPercentage === 100 &&
    machine.QRActive === true &&
    machine.Status === "OPERATIVE"
  ) {
    return 'FULL QR';
  }

  const statusMap = {
    'OPERATIVE': 'ONLINE',
    'SLEEP': 'SLEEP',
    'NIGHT_SCAN': 'NIGHTSCAN',
    'MAINTENANCE': 'MANTENIMIENTO',
    'LOCKERS_FULL': 'LOCKERS LLENOS',
    'TICKET_EMPTY': 'SIN TICKET',
    'OPERATIVE_SLEEP': 'SLEEP ONLINE',
    'MAINTENANCE_SLEEP': 'SLEEP MAINTENANCE',
    'KERONG_OTA': 'OTA KERONG',
    'BOOTLOADER_OTA': 'OTA BOOTLOADER',
    'BLE_OFF': 'POWER DOWN'
  };

  return statusMap[machine.Status] || 'UNKNOWN';
}


export function getMachineCash(machine) {

  let totalBills = (machine.Bills_in_box.five * 5.00 + machine.Bills_in_box.ten * 10.00 + machine.Bills_in_box.twenty * 20.00)

  if (totalBills <= 1500) {
    return 'OK'
  } else if (totalBills > 1500) {
    return 'FULL'
  }

}

export function getMachineStatusColor(machine) {
  const status = getMachineStatus(machine);

  const colorMap = {
    'ONLINE': '#28a745',
    'SLEEP': '#0066ff',
    'NIGHTSCAN': '#26c4f6',
    'MANTENIMIENTO': '#ff7b25',
    'LOCKERS LLENOS': '#ff0000',
    'SIN TICKET': '#ff0000',
    'SLEEP ONLINE': '#28a745',
    'SLEEP MAINTENANCE': '#ff7b25',
    'OTA KERONG': '#000000',
    'OTA BOOTLOADER': '#000000',
    'POWER DOWN': '#288BA8',
    'FULL QR': '#800080' // Assuming FULL QR should share the same color as LOCKERS LLENOS
  };

  return colorMap[status] || '#727370';
}

export function getMachineCashColor(machine) {
  let status = getMachineCash(machine)

  if (status === 'OK') {
    return '#28a745'
  } else if (status === 'FULL') {
    return '#ff0000'
  } else {
    return '#28a745'
  }
}

export function getMachinePicture(type) {

  return '/images/machines/big.png'
}

export function getMachineCirclePicture(type) {

  return '/images/machines/big_circle.png'
}

export function getMachineThumbnail(type) {

  return '/images/machines/big_thumb.png'
}

export function getMachineTypeInitial(type) {
  return type.toUpperCase()[0]
}

export function getMachineCoordinates(Location) {
  const latlng = Location.split(',')

  if (latlng.length !== 2) {
    return null
  }

  const coordinates = {
    lat: parseFloat(latlng[0]),
    lng: parseFloat(latlng[1])
  }

  if (isNaN(coordinates.lat) || isNaN(coordinates.lng)) {
    return null
  }

  return coordinates
}

export function getLockersName(name) {

  switch (name) {
    case 'LOCKERBNS':
      return 'Standard';
    case 'LOCKERCNS':
      return 'Standard Carga';
    case 'LOCKERBWS':
      return 'Standard XL';
    case 'LOCKERCWS':
      return 'Standard Carga XL';
    case 'LOCKERBNM':
      return 'Medium';
    case 'LOCKERCNM':
      return 'Medium Carga';
    case 'LOCKERBWM':
      return 'Medium XL';
    case 'LOCKERCWM':
      return 'Medium Carga XL';
    case 'LOCKERBNL':
      return 'Large';
    case 'LOCKERCNL':
      return 'Large Carga';
    case 'LOCKERBWL':
      return 'Large XL';
    case 'LOCKERCWL':
      return 'Large Carga XL';
    case 'LOCKERBNXL':
      return 'Large 4';
    case 'LOCKERCNXL':
      return 'Large 4 Carga';
    case 'LOCKERBWXL':
      return 'Large 4 XL';
    case 'LOCKERCWXL':
      return 'Large 4 Carga XL';
    case 'LOCKERBN2XL':
      return 'Large 5';
    case 'LOCKERCN2XL':
      return 'Large 5 Carga';
    case 'LOCKERBW2XL':
      return 'Large 5 XL';
    case 'LOCKERCW2XL':
      return 'Large 5 Carga XL';
    case 'LOCKERBN3XL':
      return 'Ski';
    case 'LOCKERCN3XL':
      return 'Ski Carga';
    case 'LOCKERBW3XL':
      return 'Ski XL';
    case 'LOCKERCW3XL':
      return 'Ski Carga XL';
    // Voucher/coupon locker types (X mode)
    case 'LOCKERXNS':
      return 'Voucher Standard (X)';
    case 'LOCKERXWS':
      return 'Voucher Standard XL (X)';
    case 'LOCKERXNM':
      return 'Voucher Medium (X)';
    case 'LOCKERXWM':
      return 'Voucher Medium XL (X)';
    case 'LOCKERXNL':
      return 'Voucher Large (X)';
    case 'LOCKERXWL':
      return 'Voucher Large XL (X)';
    case 'LOCKERXNXL':
      return 'Voucher Large 4 (X)';
    case 'LOCKERXWXL':
      return 'Voucher Large 4 XL (X)';
    case 'LOCKERXN2XL':
      return 'Voucher Large 5 (X)';
    case 'LOCKERXW2XL':
      return 'Voucher Large 5 XL (X)';
    case 'LOCKERXN3XL':
      return 'Voucher Ski (X)';
    case 'LOCKERXW3XL':
      return 'Voucher Ski XL (X)';
    default:
      return name;
  }
}

export const getYouTubeVideoId = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get('v');
  } catch (error) {
    console.error('Invalid URL:', url);
    return null;
  }
};